<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editRecommendation") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #267d26">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <base-select-input
            v-if="users"
            col="12"
            :optionsList="users"
            :placeholder="$t('SIDENAV.Clients.name')"
            v-model="data.user"
            required
          />

          <!-- Start:: Recommendations Repeater -->
          <div class="col-12">
            <div
              class="row align-items-center"
              v-for="(item, index) in data.recommendations"
              :key="index"
            >
              <base-select-input
                col="5"
                :optionsList="recommendationLists"
                :placeholder="$t('PLACEHOLDERS.recommendation_list')"
                v-model="item.recommendation_list_id"
                required
              />
              <base-select-input
                col="5"
                :optionsList="influencers"
                :placeholder="$t('PLACEHOLDERS.influencer_name')"
                v-model="item.influencer_id"
                required
                :disabled="!influencers"
                :style="!influencers ? 'cursor: wait;' : ''"
              />
              <div class="col-2">
                <div class="d-flex align-center justify-start h-100">
                  <v-btn
                    fab
                    x-small
                    color="error"
                    class="mx-1"
                    @click="removeRow(index)"
                    v-if="data.recommendations.length > 1"
                    elevation="0"
                  >
                    <i class="fas fa-minus white--text"></i>
                  </v-btn>
                  <v-btn
                    fab
                    x-small
                    color="success"
                    class="mx-1"
                    @click="addRow"
                    v-if="index === data.recommendations.length - 1"
                    elevation="0"
                  >
                    <i class="fas fa-plus white--text"></i>
                  </v-btn>
                </div>
              </div>
              <!-- <div class="col-12 mt-2">
              <v-btn color="primary" @click="addRow">
                <v-icon left>mdi-plus</v-icon> {{ $t("BUTTONS.add_row") }}
              </v-btn>
            </div> -->
            </div>
          </div>
          <!-- End:: Recommendations Repeater -->

          <!-- End:: Name Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EditRecommendation",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      users: [],
      influencers: [],
      recommendationLists: [],

      // Start:: Data Collection To Send
      data: {
        user: null,
        recommendations: [
          {
            recommendation_list_id: null,
            influencer_id: null,
          },
        ],
      },

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // Start:: Repeater Methods
    addRow() {
      this.data.recommendations.push({
        recommendation_list_id: null,
        influencer_id: null,
      });
    },
    removeRow(index) {
      this.data.recommendations.splice(index, 1);
    },
    // End:: Repeater Methods

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.data.user) {
        REQUEST_DATA.append("user_id", this.data.user?.id);
      }

      this.data.recommendations.forEach((item, index) => {
        if (item.recommendation_list_id) {
          REQUEST_DATA.append(
            `recommendations[${index}][recommendation_list_id]`,
            item.recommendation_list_id?.id || item.recommendation_list_id
          );
        }
        if (item.influencer_id) {
          REQUEST_DATA.append(
            `recommendations[${index}][influencer_id]`,
            item.influencer_id?.id || item.influencer_id
          );
        }
      });

      REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `recommendations/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/recommendations/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showRecommendation() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `recommendations/${this.$route.params.id}`,
        });

        const recommendation = res.data.data.Recommendation;

        // Map User
        this.data.user = recommendation.user;
        this.users = [
          {
            id: recommendation.user.id,
            name: recommendation.user.name,
            ...recommendation.user,
          },
        ];

        // Map Recommendations from flat structure
        this.data.recommendations = [];

        if (
          recommendation.recommendations &&
          recommendation.recommendations.length > 0
        ) {
          recommendation.recommendations.forEach((item) => {
            this.data.recommendations.push({
              recommendation_list_id: item.recommendations_list,
              influencer_id: item.influencer,
            });
          });
        }
        // Fallback for empty data
        if (this.data.recommendations.length === 0) {
          this.data.recommendations.push({
            recommendation_list_id: null,
            influencer_id: null,
          });
        }
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // end show data

    // start get users
    async getUsers() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "clients?page=0&limit=0&is_active=1",
        });
        this.users = res.data.data.data.map((item) => ({
          id: item.id,
          name: item.name || item.email,
          ...item,
        }));
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // end get users

    // start get influencers
    async getInfluencers() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "influencers?page=0&limit=0&is_active=1",
        });
        this.influencers = res.data.data.data.map((item) => ({
          id: item.id,
          name: item.name || item.nick_name,
          ...item,
        }));
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // end get influencers

    // Start:: Get Recommendation Lists
    async getRecommendationLists() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "recommendation-lists?limit=0&page=0",
        });
        this.recommendationLists = res.data.data.data.map((item) => ({
          id: item.id,
          name: item.name_ar || item.name || item.name_en,
          ...item,
        }));
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // End:: Get Recommendation Lists
  },

  created() {
    this.showRecommendation();
    this.getUsers();
    this.getInfluencers();
    this.getRecommendationLists();
  },
};
</script>
